module.exports = __webpack_public_path__ + "static/media/1006152.157285b8.png";